var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"banner"}},[_c('img',{attrs:{"src":"https://picbed.qunarzz.com/9002ec208380c16bf4bb8fa2d616bcc1.jpg","alt":""}})])}]

export { render, staticRenderFns }